import * as CANNON from "cannon-es";
import { Signal } from "../core/Signal";
import type { QualitySettings } from "../perf/QualityManager";

export interface ContactEvent {
  bodyA: CANNON.Body;
  bodyB: CANNON.Body;
}

const FIXED_STEP = 1 / 60;

export class PhysicsWorld {
  readonly world: CANNON.World;
  readonly onContact = new Signal<ContactEvent>();
  readonly onBeginContact = new Signal<ContactEvent>();
  private maxSubSteps: number;

  constructor(_quality?: QualitySettings) {
    this.world = new CANNON.World();
    this.world.gravity.set(0, -9.82, 0);
    this.world.broadphase = new CANNON.SAPBroadphase(this.world);
    this.world.allowSleep = true;
    (this.world.solver as CANNON.GSSolver).iterations = 8;
    this.world.defaultContactMaterial.friction = 0.3;
    this.world.defaultContactMaterial.restitution = 0.0;
    this.maxSubSteps = 3;

    this.world.addEventListener("beginContact", (ev: { bodyA: CANNON.Body; bodyB: CANNON.Body }) => {
      this.onBeginContact.emit({ bodyA: ev.bodyA, bodyB: ev.bodyB });
    });
    this.world.addEventListener("postStep", () => {
      const contacts = this.world.contacts;
      for (let i = 0; i < contacts.length; i++) {
        const c = contacts[i]!;
        this.onContact.emit({ bodyA: c.bi, bodyB: c.bj });
      }
    });
  }

  step(dt: number): void {
    this.world.step(FIXED_STEP, dt, this.maxSubSteps);
  }

  setGravity(x: number, y: number, z: number): void {
    this.world.gravity.set(x, y, z);
  }

  addBody(body: CANNON.Body): void {
    this.world.addBody(body);
  }

  removeBody(body: CANNON.Body): void {
    this.world.removeBody(body);
  }

  dispose(): void {
    this.onContact.clear();
    this.onBeginContact.clear();
    while (this.world.bodies.length > 0) {
      this.world.removeBody(this.world.bodies[0]!);
    }
  }
}
